<template>
    <div id="app">
        <v-app id="inspire">
            <v-layout>
            <v-flex xs10 offset-xs1>
                <v-card class="justify-center">
                <!-- <v-img
                    class="white--text"
                    height="200px"
                    src="https://www.rgcltd.co.uk/wp-content/uploads/2013/09/rgc-user-guide-banner.jpg"
                >
                    <v-container fill-height fluid>
                    <v-layout fill-height>
                        <v-flex xs12 align-end flexbox>
                        </v-flex>
                    </v-layout>
                    </v-container>
                </v-img> -->
                    <div class="text-xs-center">
                        <v-container>
                        <iframe src="https://docs.google.com/a/scinnova.com.ph/document/d/e/2PACX-1vQ-v06SYY2HiKLT2gDCi1AlBB6GJTtXNagSOBoC7J1YnhdUqIh0_ENh5BPsOZdv5nFHetxHvHvXeh5d/pub?embedded=true" width="100%" height="5450" frameborder="0"></iframe>
                        </v-container>
                    </div>
              
                <v-footer light  height="auto" width="100%">
                    <v-card flat tile
                        class="blue white--text text-xs-center"
                        width="100%"
                    >
                        <v-card-text class="white--text">&copy;2019 — <strong>Cloud Ops</strong></v-card-text>
                    </v-card>
                </v-footer>

                </v-card>
            </v-flex>
            </v-layout>
        </v-app>
    </div>
</template>

<script>

export default {
    data: () => ({
    loaded: false,
}),

    methods : {

    },

    mounted() {

    }

}
</script>
